var abilitiesGer = {
    "1": "Duftnote",
    "2": "Niesel",
    "3": "Temposchub",
    "4": "Kampfpanzer",
    "5": "Robustheit",
    "6": "Feuchtigkeit",
    "7": "Flexibilit\u00e4t",
    "8": "Sandschleier",
    "9": "Statik",
    "10": "Voltabsorber",
    "11": "H2O-Absorber",
    "12": "D\u00f6sigkeit",
    "13": "Wolke Sieben",
    "14": "Facettenauge",
    "15": "Insomnia",
    "16": "Farbwechsel",
    "17": "Immunit\u00e4t",
    "18": "Feuerf\u00e4nger",
    "19": "Puderabwehr",
    "20": "Gleichmut",
    "21": "Saugnapf",
    "22": "Bedroher",
    "23": "Wegsperre",
    "24": "Rauhaut",
    "25": "Wunderwache",
    "26": "Schwebe",
    "27": "Sporenwirt",
    "28": "Synchro",
    "29": "Neutraltorso",
    "30": "Innere Kraft",
    "31": "Blitzf\u00e4nger",
    "32": "Edelmut",
    "33": "Wassertempo",
    "34": "Chlorophyll",
    "35": "Erleuchtung",
    "36": "Erfassen",
    "37": "Kraftkoloss",
    "38": "Giftdorn",
    "39": "Konzentrator",
    "40": "Magmapanzer",
    "41": "Aquah\u00fclle",
    "42": "Magnetfalle",
    "43": "L\u00e4rmschutz",
    "44": "Regengenuss",
    "45": "Sandsturm",
    "46": "Erzwinger",
    "47": "Speckschicht",
    "48": "Fr\u00fchwecker",
    "49": "Flammk\u00f6rper",
    "50": "Angsthase",
    "51": "Adlerauge",
    "52": "Scherenmacht",
    "53": "Mitnahme",
    "54": "Schnarchnase",
    "55": "\u00dcbereifer",
    "56": "Charmebolzen",
    "57": "Plus",
    "58": "Minus",
    "59": "Prognose",
    "60": "Klebek\u00f6rper",
    "61": "Expidermis",
    "62": "Adrenalin",
    "63": "Notschutz",
    "64": "Kloakenso\u00dfe",
    "65": "Notd\u00fcnger",
    "66": "Gro\u00dfbrand",
    "67": "Sturzbach",
    "68": "Hexaplaga",
    "69": "Steinhaupt",
    "70": "D\u00fcrre",
    "71": "Ausweglos",
    "72": "Munterkeit",
    "73": "Pulverrauch",
    "74": "Mentalkraft",
    "75": "Panzerhaut",
    "76": "Klimaschutz",
    "77": "Taumelschritt",
    "78": "Starthilfe",
    "79": "Rivalit\u00e4t",
    "80": "Felsenfest",
    "81": "Schneemantel",
    "82": "V\u00f6llerei",
    "83": "Kurzschluss",
    "84": "Entlastung",
    "85": "Hitzeschutz",
    "86": "Wankelmut",
    "87": "Trockenheit",
    "88": "Download",
    "89": "Eisenfaust",
    "90": "Giftheilung",
    "91": "Anpassung",
    "92": "Wertelink",
    "93": "Hydration",
    "94": "Solarkraft",
    "95": "Rasanz",
    "96": "Regulierung",
    "97": "Supersch\u00fctze",
    "98": "Magieschild",
    "99": "Schildlos",
    "100": "Zeitspiel",
    "101": "Techniker",
    "102": "Floraschild",
    "103": "Tollpatsch",
    "104": "\u00dcberbr\u00fcckung",
    "105": "Gl\u00fcckspilz",
    "106": "Finalschlag",
    "107": "Vorahnung",
    "108": "Vorwarnung",
    "109": "Unkenntnis",
    "110": "Aufwertung",
    "111": "Filter",
    "112": "Saumselig",
    "113": "Rauflust",
    "114": "Sturmsog",
    "115": "Eishaut",
    "116": "Felskern",
    "117": "Schneeschauer",
    "118": "Honigmaul",
    "119": "Schn\u00fcffler",
    "120": "Achtlos",
    "121": "Variabilit\u00e4t",
    "122": "Pflanzengabe",
    "123": "Alptraum",
    "124": "Langfinger",
    "125": "Rohe Gewalt",
    "126": "Umkehrung",
    "127": "Anspannung",
    "128": "Siegeswille",
    "129": "Schw\u00e4chling",
    "130": "Tastfluch",
    "131": "Heilherz",
    "132": "Freundeshut",
    "133": "Bruchr\u00fcstung",
    "134": "Schwermetall",
    "135": "Leichtmetall",
    "136": "Multischuppe",
    "137": "Giftwahn",
    "138": "Hitzewahn",
    "139": "Reiche Ernte",
    "140": "Telepathie",
    "141": "Gef\u00fchlswippe",
    "142": "Partikelschutz",
    "143": "Giftgriff",
    "144": "Belebekraft",
    "145": "Brustbieter",
    "146": "Sandscharrer",
    "147": "Wunderhaut",
    "148": "Analyse",
    "149": "Trugbild",
    "150": "Doppelg\u00e4nger",
    "151": "Schwebedurch",
    "152": "Mumie",
    "153": "Hochmut",
    "154": "Redlichkeit",
    "155": "Hasenfu\u00df",
    "156": "Magiespiegel",
    "157": "Vegetarier",
    "158": "Strolch",
    "159": "Sandgewalt",
    "160": "Eisenstachel",
    "161": "Trance-Modus",
    "162": "Triumphstern",
    "163": "Turbobrand",
    "164": "Teravolt",
    "165": "Dufth\u00fclle",
    "166": "Bl\u00fctenh\u00fclle",
    "167": "Backentaschen",
    "168": "Wandlungskunst",
    "169": "Fellkleid",
    "170": "Zauberer",
    "171": "Kugelsicher",
    "172": "Unbeugsamkeit",
    "173": "Titankiefer",
    "174": "Frostschicht",
    "175": "Zuckerh\u00fclle",
    "176": "Taktikwechsel",
    "177": "Orkanschwingen",
    "178": "Megawumme",
    "179": "Pflanzenpelz",
    "180": "Symbiose",
    "181": "Krallenwucht",
    "182": "Feenschicht",
    "183": "Viskosit\u00e4t",
    "184": "Zenithaut",
    "185": "Familienbande",
    "186": "Dunkelaura",
    "187": "Feenaura",
    "188": "Aura-Umkehr",
    "189": "Urmeer",
    "190": "Endland",
    "191": "Delta-Wind",
    "192": "Z\u00e4higkeit",
    "193": "Rei\u00dfaus",
    "194": "R\u00fcckzug",
    "195": "Verklumpen",
    "196": "Qu\u00e4lerei",
    "197": "Limitschild",
    "198": "Beschattung",
    "199": "Wasserblase",
    "200": "Stahlprofi",
    "201": "Wutausbruch",
    "202": "Schneescharrer",
    "203": "Langstrecke",
    "204": "Pl\u00e4tscherstimme",
    "205": "Heilwandel",
    "206": "Elektrohaut",
    "207": "Surf-Schweif",
    "208": "Fischschwarm",
    "209": "Kost\u00fcmspuk",
    "210": "Freundschaftsakt",
    "211": "Scharwandel",
    "212": "Korrosion",
    "213": "Dauerschlaf",
    "214": "Majest\u00e4t",
    "215": "Magenkrempler",
    "216": "T\u00e4nzer",
    "217": "Batterie",
    "218": "Flauschigkeit",
    "219": "Buntk\u00f6rper",
    "220": "Seelenherz",
    "221": "Lockenkopf",
    "222": "Receiver",
    "223": "Chemiekraft",
    "224": "Bestien-Boost",
    "225": "Alpha-System",
    "226": "Elektro-Erzeuger",
    "227": "Psycho-Erzeuger",
    "228": "Nebel-Erzeuger",
    "229": "Gras-Erzeuger",
    "230": "Metallprotektor",
    "231": "Phantomschutz",
    "232": "Prismar\u00fcstung",
    "233": "Zerebralmacht",
    "234": "K\u00fchnes Schwert",
    "235": "Wackerer Schild",
    "236": "Libero",
    "237": "Apport",
    "238": "Wollflaum",
    "239": "Schraubflosse",
    "240": "Spiegelr\u00fcstung",
    "241": "W\u00fcrggeschoss",
    "242": "Stahlr\u00fcckgrat",
    "243": "Dampfantrieb",
    "244": "Punk Rock",
    "245": "Sandspeier",
    "246": "Eisfl\u00fcgelstaub",
    "247": "Heranreifen",
    "248": "Tiefk\u00fchlkopf",
    "249": "Kraftquelle",
    "250": "Mimese",
    "251": "Hemmungslos",
    "252": "St\u00e4hlerner Wille",
    "253": "Unheilsk\u00f6rper",
    "254": "Rastlose Seele",
    "255": "Affenfokus",
    "256": "Reaktionsgas",
    "257": "Pastellh\u00fclle",
    "258": "Hei\u00dfhunger",
    "259": "Schnellschuss",
    "260": "Verborgene Faust",
    "261": "Kuriose Arznei",
    "262": "Transistor",
    "263": "Drachenkiefer",
    "264": "Helles Wiehern",
    "265": "Dunkles Wiehern",
    "266": "Reitgespann",
    "267": "Reitgespann",
    "268": "Duftschwade",
    "269": "Streusaat",
    "270": "Thermowandel",
    "271": "Wutpanzer",
    "272": "L\u00e4utersalz",
    "273": "Knusperkruste",
    "274": "Windreiter",
    "275": "Wachhund",
    "276": "Steintr\u00e4ger",
    "277": "Windkraft",
    "278": "Superwechsel",
    "279": "Kommandant",
    "280": "Dynamo",
    "281": "Pal\u00e4osynthese",
    "282": "Quantenantrieb",
    "283": "Goldk\u00f6rper",
    "284": "Unheilsgef\u00e4\u00df",
    "285": "Unheilsschwert",
    "286": "Unheilstafeln",
    "287": "Unheilsjuwelen",
    "288": "Orichalkum-Puls",
    "289": "Hadronen-Motor",
    "290": "Profiteur",
    "291": "Wiederk\u00e4uer",
    "292": "Scharfkantig",
    "293": "Feldherr",
    "294": "Synchronauftritt",
    "295": "Giftbelag",
    "296": "Schweifr\u00fcstung",
    "297": "Bodenschmaus",
    "298": "Myzelienkraft",
    "299": "Gastlichkeit",
    "300": "Geistiges Auge",
    "301": "Maskenmacht",
    "302": "Maskenmacht",
    "303": "Maskenmacht",
    "304": "Maskenmacht",
    "305": "Giftkette",
    "306": "S\u00fc\u00dfer Nektar",
    "307": "Tera-Wandel",
    "308": "Tera-Panzer",
    "309": "Teraforming Null"
}
export default abilitiesGer;